import {useEffect } from "react";
import DataLoader from "../../Utils/DataLoader";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL} from "../../constants/matcher";
import { Link } from "react-router-dom";


const Training = () => 
{
    const [assignmentList, setAssignmentList] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    useEffect(() => 
    {
        const token = JSON.parse(localStorage.getItem("user-token"));
        const fetchAssignment = async() =>
        {
            try{
                return await fetch(HTTPURL+'user/get-all-assignments',{headers:{"Authorization" :`Bearer ${token}`} })
                .then((response) => response.json())
                .then((data) => {
                    setAssignmentList(data.data,() => setShowResults(true))
                });
            } catch(err) {
                console.log(err);
            }
        }
        fetchAssignment();
    },[]);
    return (
        <main>
            <div className="container-fluid px-4">
                <div className="row mb-4">
                    <div className="col-xl-12">
                        <div className="card mb-4">
                            <span className="heading mb-4">
                                <button className="mt-4 mb-3"> <i class="fa-solid fa-people-arrows"></i> Match- Making</button>
                                <i className="fa fa-check-circle"></i><label className="">Monitoring & Evaluation</label>
                            </span>
                            <h4 className="">Match-Making with Mentors</h4>
                            <span className=""> Matching member with efficient mentors </span>
                            <div class="card" style={{width: '18rem'}}>
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
                                    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Training;